import { z } from "zod"
import { validateCPF } from "@/lib/custom-validations"
import { dateRangeSchema } from "@/lib/date-schema"

export const personPFSchema = z.object({
  completeName: z.string().min(1, "Nome completo é obrigatório"),
  socialName: z.string().optional(),
  artisticName: z.string().optional(),
  role: z.string().min(1, "Função é obrigatória"),
  rg: z.string().min(1, "RG é obrigatório"),
  cpf: z
    .string()
    .min(11, "CPF deve ter 11 dígitos")
    .refine((value) => {
      const cleanValue = value.replace(/\D/g, "")
      return cleanValue.length === 11 && validateCPF(cleanValue)
    }, { message: "CPF inválido" }),
  birthDate: dateRangeSchema,
  birthPlace: z.string().min(1, "Local de nascimento é obrigatório"),
  nationality: z.string().min(1, "Nacionalidade é obrigatória"),
  countryEntryDate: z.date().optional(),
  maritalStatus: z.string().min(1, "Estado civil é obrigatório"),
  pronouns: z.string().min(1, "Pronomes são obrigatórios"),
  cellphone: z.string().min(1, "Celular é obrigatório"),
  tshirtNumber: z.string().optional(),
  address: z.string().min(1, "Endereço residencial é obrigatório"),
  neighborhood: z.string().min(1, "Bairro é obrigatório"),
  city: z.string().min(1, "Cidade é obrigatória"),
  state: z.string().min(1, "Estado é obrigatório"),
  zipCode: z.string().min(8, "CEP deve ter 8 dígitos"),
  healthPlan: z.string().optional(),
  planCoverage: z.string().optional(),
  emergencyContact: z.string().optional(),
  bloodType: z.string().optional(),
  allergies: z.string().optional(),
  coronavirusVaccination: z.string().optional(),
  dietaryRestrictions: z.string().optional(),
  bank: z.string().optional(),
  branch: z.string().optional(),
  checkingAccount: z.string().optional(),
  pixKey: z.string().optional(),
})

export type PersonPFSchema = z.infer<typeof personPFSchema>
